import { render, staticRenderFns } from "./CalendarEventsDialog.vue?vue&type=template&id=8de9a614&scoped=true"
import script from "./CalendarEventsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventsDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarEventsDialog.vue?vue&type=style&index=0&id=8de9a614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de9a614",
  null
  
)

export default component.exports